import { JSResourceForInteraction } from '@atlassian/react-async';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

export const workflowStatusProjectLimitMetricDetailEntryPoint: ReturnType<
	typeof createPageEntryPoint
> = createPageEntryPoint({
	main: {
		root: JSResourceForInteraction(
			() =>
				import(
					/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-workflow-status-project-limit" */ '@jira/spa-apps__admin-pages-performance-metric-detail-workflow-status-project-limit/src/WorkflowStatusProjectLimitDetail.tsx'
				),
		),
		getPreloadProps: () => ({}),
	},
});
